export const TYPES = {
  SET_DIALOG_EDITED_ALL: "dialog_edited/SET_DIALOG_EDITED_ALL",
  SET_DIALOG_EDITED_SPEAKERS: "dialog_edited/SET_DIALOG_EDITED_SPEAKERS",
  SET_DIALOG_EDITED_COMMENTS: "dialog_edited/SET_DIALOG_EDITED_COMMENTS",
};
